module.exports = __webpack_public_path__ + "Simple-Line-Icons.b2892aa62b0fb2c21c8d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.ttf?-i3a2kk
// module id = ../../../../../src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.ttf?-i3a2kk
// module chunks = styles